export default function Django_Certificate() {
  return <div>Django_Certificate Component</div>;
}
